import { render, staticRenderFns } from "./Layout-externo1.vue?vue&type=template&id=9a100cd2"
import script from "./Layout-externo1.vue?vue&type=script&lang=js"
export * from "./Layout-externo1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports